export default (config) => ({
  activeTab: config.activeTab,
  fabricStyling: "",
  detailsBullets: "",
  init() {
    if (this.activeTab == window.location.hash.replace("#", "")) {
      this.activeTab = window.location.hash.replace("#", "");
    } else {
      this.activeTab =
        window.location.hash.replace("#", "") || "productDescription";
    }

    this.fabricStyling = getFabricStyling(config.fabricStyling);
    this.detailsBullets = getDetailsBullets(config.details);
    this.modelDetails = getModelDetails(config.model);
  },
});
function getDetailsBullets(str) {
  if (!str) return "";

  // Get array of rows
  let rows = str.split("\n");
  let htmlRows = ``;

  for (let i = 0; i < rows.length; i++) {
    if (rows[i].length !== 0) {
      let newRow = /* html*/ `<div class="details-bullets-row">
      <span class="details-bullet-symbol">•</span>${rows[i]}
      </div>`;

      htmlRows = htmlRows.concat(newRow);
    }
  }

  return htmlRows;
}
function getFabricStyling(str) {
  if (!str) return "";
  // Get array of rows
  let rows = str.split("\n");
  let htmlRows = ``;

  for (let i = 0; i < rows.length; i++) {
    let items = rows[i].split(" ");
    // Remove empty items
    if (items.length !== 3) {
      items = items.filter((item) => item !== "");
    }
    // Transform - and + to circles
    let circles = items[1]
      .replaceAll("-", /* html*/ `<span class="circle-empty"></span>`)
      .replaceAll("+", /* html*/ `<span class="circle-filled"></span>`);
    let newRow = /* html*/ `<div class="fabric-styling-row">
      <div>${items[0]}</div><div>${circles}</div><div>${items[2]}</div>
      </div>`;
    htmlRows = htmlRows.concat(newRow);
  }

  return htmlRows;
}

function getModelDetails(str) {
  if (!str) return "";

  // Get array of rows
  let rows = str.split("\n");
  let htmlRows = ``;

  for (let i = 0; i < rows.length; i++) {
    if (rows[i].length !== 0) {
      let newRow = /* html*/ `<p class="model-details-row">
${rows[i]}
      </p>`;

      htmlRows = htmlRows.concat(newRow);
    }
  }

  return htmlRows;
}

function getDescription(html) {
  let start = html.indexOf("<strong>") + 8;
  let end = html.lastIndexOf("</strong>");
  let description = html
    .substring(start, end)
    .replaceAll("<strong>", "")
    .replaceAll("</strong>", "");
  return description;
}


function getDetailsList(html) {
  let start = html.indexOf("<ul>") + 5;
  let end = html.indexOf("</ul>");
  let detailsList = html.substring(start, end);
  return detailsList;
}

function getBullets(str) {
  if (!str) return "";
  return str.replaceAll("-", "◦").replaceAll("+", "•");
}
